import React, { useEffect } from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturedCategories from './components/FeaturedCategories';
import PhotoGallery from './components/PhotoGallery';
import MaterialsPreview from './components/MaterialsPreview';
import WhatsAppFloat from './components/WhatsAppFloat';
import Footer from './components/Footer';

const Homepage = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "PH Móveis Artesanais",
    "description": "Móveis artesanais únicos em madeiras nobres brasileiras. Tradição artesanal, design contemporâneo e personalização completa.",
    "url": "https://phmoveis.com.br",
    "telephone": "+55-62-99326-3202",
    "email": "phmoveisconteporaneos@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua dos Artesãos, 123",
      "addressLocality": "São Paulo",
      "addressRegion": "SP",
      "postalCode": "05435-000",
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -23.5505,
      "longitude": -46.6333
    },
    "openingHours": "Mo-Fr 08:00-18:00, Sa 08:00-14:00",
    "priceRange": "$$$",
    "sameAs": [
      "https://www.instagram.com/phmoveisartesanais",
      "https://www.facebook.com/phmoveisartesanais"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Móveis Artesanais",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "Móveis de Madeira Nobre",
            "description": "Móveis artesanais únicos em madeiras nobres brasileiras",
            "category": "Furniture",
            "brand": {
              "@type": "Brand",
              "name": "PH Móveis Artesanais"
            },
            "material": ["Madeira de Ipê", "Madeira de Cumaru", "Madeira de Teca", "Madeira de Peroba"]
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Móveis Únicos, Feitos Especialmente para Você"
        description="Móveis artesanais únicos em madeiras nobres brasileiras. Tradição artesanal, design contemporâneo e personalização completa. Consultoria gratuita e garantia vitalícia."
        keywords="móveis artesanais, móveis personalizados, madeira nobre, móveis sob medida, marcenaria artesanal, móveis brasileiros, design contemporâneo, ipê, cumaru, teca, peroba, móveis de madeira, marcenaria, artesanato"
        image="https://phmoveis.com.br/assets/og-image.jpg"
        url="https://phmoveis.com.br"
        structuredData={structuredData}
      />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <StatsSection />
          <FeaturedCategories />
          <PhotoGallery />
          <MaterialsPreview />
        </main>

        <Footer />
        <WhatsAppFloat />
      </div>
    </>
  );
};

export default Homepage;